import React from "react";
import Styles from './styles.module.scss';
import {useSelector} from "react-redux";
import Moment from "react-moment";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {formatNumber} from "../cabinetShell/config";

import dirInIcon from '../../theme/assets/redesign/wallet/dir_in.svg';
import dirOutIcon from '../../theme/assets/redesign/wallet/dir_out.svg';
import chevronIcon from '../../theme/assets/redesign/m_chevron.svg';


// статус из API -> вид бейджа из макета
const STATUS = {
    confirmed: {label: 'Подтвержден', tone: 'positive'},
    created: {label: 'В обработке', tone: 'warning'},
    pending: {label: 'В обработке', tone: 'warning'},
    canceled: {label: 'Отменен', tone: 'muted'},
    expired: {label: 'Время истекло', tone: 'danger'},
};

const TYPE = {
    receive: {label: 'Пополнение', direction: 'in'},
    withdraw: {label: 'Вывод', direction: 'out'},
};


const CabinetWalletHistory = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const walletHistory = useSelector(store => store.cabinet.walletHistory);
    const transactions = walletHistory?.transactions || [];

    return (
        <section className={Styles.container}>
            <div className={Styles.titleRow}>
                <div className={Styles.title}>{t('Недавние транзакции')}</div>
                <div className={Styles.seeAll} onClick={() => navigate('/transactions')}>
                    <span>{t('Смотреть все')}</span>
                    <img src={chevronIcon} alt="" width="14" height="14"/>
                </div>
            </div>

            <div className={Styles.header}>
                <div className={Styles.colDir}/>
                <div className={Styles.col}>{t('Дата')}</div>
                <div className={Styles.col}>{t('Время')}</div>
                <div className={Styles.col}>{t('Сумма')}</div>
                <div className={Styles.col}>{t('Тип')}</div>
                <div className={`${Styles.colStatus} ${Styles.colStatusHead}`}>{t('Статус')}</div>
            </div>

            <div className={Styles.body}>
                {transactions.length > 0 ? transactions.map((item, index) => {
                    const type = TYPE[item.type] || {label: item.type, direction: 'in'};
                    const status = STATUS[item.status] || {label: item.status, tone: 'muted'};
                    const code = item?.currency?.code || '';
                    const amountEl = (
                        <div className={`${Styles.amount} ${code === 'FTF' ? Styles.amountFtf : ''} ${item.status === 'canceled' ? Styles.amountCanceled : ''}`}>
                            <span>{formatNumber(item.amount, 6)}</span>
                            <span>{code}</span>
                        </div>
                    );
                    const badgeEl = <div className={`${Styles.badge} ${Styles[`badge_${status.tone}`]}`}>{t(status.label)}</div>;
                    return (
                        <div className={Styles.row} key={item.id ?? 'transactionItem' + index}>
                            <div className={Styles.colDir}>
                                <img src={type.direction === 'out' ? dirOutIcon : dirInIcon} alt=""/>
                            </div>

                            {/* десктоп: колонки таблицы */}
                            <div className={`${Styles.col} ${Styles.date} ${Styles.desktopOnly}`}>
                                <Moment format="DD.MM.YYYY">{item.created_at}</Moment>
                            </div>
                            <div className={`${Styles.col} ${Styles.time} ${Styles.desktopOnly}`}>
                                <Moment format="HH:mm">{item.created_at}</Moment>
                            </div>
                            <div className={`${Styles.col} ${Styles.desktopOnly}`}>{amountEl}</div>
                            <div className={`${Styles.col} ${Styles.type} ${Styles.desktopOnly}`}>{t(type.label)}</div>
                            <div className={`${Styles.colStatus} ${Styles.desktopOnly}`}>{badgeEl}</div>

                            {/* мобилка: тип + дата слева, сумма + статус справа */}
                            <div className={`${Styles.mInfo} ${Styles.mobileOnly}`}>
                                <div className={Styles.mType}>{t(type.label)}</div>
                                <div className={Styles.mMeta}>
                                    <Moment format="DD.MM.YYYY">{item.created_at}</Moment>
                                    <span>·</span>
                                    <Moment format="HH:mm">{item.created_at}</Moment>
                                </div>
                            </div>
                            <div className={`${Styles.mValue} ${Styles.mobileOnly}`}>
                                {amountEl}
                                {badgeEl}
                            </div>
                        </div>
                    );
                }) : <div className={Styles.empty}>{t('Транзакций пока нет')}</div>}
            </div>
        </section>
    );
};

export default CabinetWalletHistory;
